export enum FtmReportsRegMessages {
  ARCHIVE_HEADING = 'Are you sure you want to archive the registration(s)',
  ARCHIVE_LABEL = 'Archive',
}
